import { Nav } from '@/components/sections/Nav';
import { Hero } from '@/components/sections/Hero';
import { DealTicker } from '@/components/sections/DealTicker';
import { SocialProof } from '@/components/sections/SocialProof';
import { HowItWorks } from '@/components/sections/HowItWorks';
import { DecayDemo } from '@/components/sections/DecayDemo';
import { ForShoppers } from '@/components/sections/ForShoppers';
import { ForMerchants } from '@/components/sections/ForMerchants';
import { Faq } from '@/components/sections/Faq';
import { WaitlistCta } from '@/components/sections/WaitlistCta';
import { Footer } from '@/components/sections/Footer';

export function App() {
  return (
    <>
      <Nav />
      <Hero />
      <DealTicker />
      <SocialProof />
      <HowItWorks />
      <DecayDemo />
      <ForShoppers />
      <ForMerchants />
      <Faq />
      <WaitlistCta />
      <Footer />
    </>
  );
}
